import icon from 'vue-svgicon';

icon.register({
    'regular/arrow-thick-up': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M7.5 22.5v-9.75H3.758a.749.749 0 0 1-.587-1.223l8.242-10.5a.761.761 0 0 1 1.174 0l8.242 10.5a.749.749 0 0 1-.587 1.223H16.5v9.75a.753.753 0 0 1-.756.75H8.256a.753.753 0 0 1-.756-.75z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
